import React from "react";
import Modal from "react-modal";
import CreditRemoveInner from "./CreditRemoveInner";
import { useSelector } from "react-redux";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(31, 32, 33, 0.9)"
  }
};

const RemoveCreditCardModal = () => {
  const open = useSelector(
    state => state.userActions.showRemoveCreditCardModal
  );
  return (
    <Modal
      className="Modal__Bootstrap modal-dialog remove-credit-card"
      closeTimeoutMS={150}
      isOpen={open}
      contentLabel="Support"
      style={customStyles}
    >
      <CreditRemoveInner />
    </Modal>
  );
};

export default RemoveCreditCardModal;
